/* ==========================================================================
   LP Creators 2026 — interações das landings das parceiras.
   Carregado SOMENTE pela section lp-creator-config. Só age em elementos com
   atributos data-lpc-*; não toca em nada fora das landings.
   ========================================================================== */

(() => {
  if (window.__lpCreator) return;
  window.__lpCreator = true;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function readConfig() {
    const el = document.getElementById('lpc-config');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent) || {};
    } catch (e) {
      return {};
    }
  }

  const config = readConfig();

  /* Insider: page_view com o nome da LP (mesmo formato das LPs de oferta, lp-ofr.js).
     O ins.js carrega async: espera até ~10s por ele. */
  if (config.insiderPage) {
    const send = () => {
      if (!(window.Insider && typeof window.Insider.track === 'function')) return false;
      const params = { src: 'web', url: window.location.href, page_name: config.insiderPage };
      window.Insider.track('events', [
        {
          event_name: 'page_view',
          timestamp: new Date().toISOString().replace(/\.\d{3}Z$/, 'Z'),
          event_params: Object.assign({}, params, { custom: params }),
        },
      ]);
      return true;
    };
    if (!send()) {
      let tries = 0;
      const timer = setInterval(() => {
        if (send() || ++tries > 100) clearInterval(timer);
      }, 100);
    }
  }

  /* UTMs da visita no carrinho (mesma lógica das LPs de sampling, lp-sampling.js):
     o checkout abre num link novo, sem as UTMs da LP; gravadas como atributos do
     carrinho, aparecem no pedido em "Detalhes adicionais" (note_attributes). */
  const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  const visitUtms = (() => {
    let utms = {};
    try {
      const params = new URLSearchParams(window.location.search);
      UTM_KEYS.forEach((key) => {
        const value = params.get(key);
        if (value) utms[key] = value.slice(0, 255);
      });
      if (Object.keys(utms).length) sessionStorage.setItem('lp-creator-utms', JSON.stringify(utms));
      else utms = JSON.parse(sessionStorage.getItem('lp-creator-utms') || '{}') || {};
    } catch (e) {
      /* sem sessionStorage: só as da URL */
    }
    return utms;
  })();

  // Grava as 5 chaves sempre (vazio apaga a de uma visita anterior) e desiste em 3s
  function saveUtms() {
    const attributes = {};
    UTM_KEYS.forEach((key) => (attributes[key] = visitUtms[key] || ''));
    const request = fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes }),
    }).catch(() => {});
    return Promise.race([request, new Promise((resolve) => setTimeout(resolve, 3000))]);
  }

  // Link de reserva (sem o JS do carrinho da loja): kit + UTMs
  function fallbackHref() {
    const params = ['checkout'];
    UTM_KEYS.filter((key) => visitUtms[key]).forEach((key) => {
      params.push(`attributes[${key}]=${encodeURIComponent(visitUtms[key])}`);
    });
    return `/cart/${config.variantId}:1?${params.join('&')}`;
  }

  function trackAddToCart() {
    if (window.mixpanel && typeof window.mixpanel.track === 'function') {
      window.mixpanel.track('Added to Cart', { name: config.productTitle });
    }
    try {
      if (!config.insiderPage || !(window.Insider && typeof window.Insider.track === 'function')) return;
      window.Insider.track('events', [
        {
          event_name: 'ecom_add_to_cart',
          timestamp: new Date().toISOString().replace(/\.\d{3}Z$/, 'Z'),
          event_params: {
            pid: String(config.variantId),
            c_product_name: config.productTitle,
            p_price: config.insiderPrice,
            c_event_source: config.insiderPage,
          },
        },
      ]);
    } catch (e) {
      /* rastreio nunca impede o resgate */
    }
  }

  /* Botões: resgatam o kit de amostras (mesmo fluxo do "Resgatar" das LPs de
     sampling): limpa o carrinho, adiciona o kit e segue para /checkout.
     Bloqueia se o cliente já resgatou (tag) ou se esgotou.
     Com o "Link fixo" preenchido no editor, os botões vão para ele. */
  function initCtas(scope) {
    scope.querySelectorAll('[data-lpc-cta]').forEach((link) => {
      if (link.dataset.lpcReady) return;
      link.dataset.lpcReady = 'true';

      if (config.cart) {
        link.href = config.cart;
        return;
      }
      if (!config.variantId) return;

      if (config.state !== 'available') {
        const label = config.state === 'claimed' ? config.labels.claimed : config.labels.soldOut;
        const text = link.querySelector('span') || link;
        text.textContent = label;
        link.removeAttribute('href');
        link.setAttribute('aria-disabled', 'true');
        link.classList.add('is-disabled');
        return;
      }

      link.href = fallbackHref();
      link.addEventListener('click', (event) => {
        if (!link.dataset.lpcBusy) trackAddToCart();
        // Sem global.js, o link /cart/<variante>:1 faz o mesmo
        if (typeof window.addSelectedVariantToCart !== 'function') return;
        event.preventDefault();
        if (link.dataset.lpcBusy) return;
        link.dataset.lpcBusy = 'true';
        link.setAttribute('aria-busy', 'true');
        saveUtms()
          .then(() => window.addSelectedVariantToCart(config.variantId, 1, true))
          .catch(() => {
            delete link.dataset.lpcBusy;
            link.removeAttribute('aria-busy');
            window.location.href = link.href;
          });
      });
    });
  }

  /* Voltar do checkout (bfcache) não pode deixar o botão preso no carregando */
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    document.querySelectorAll('[data-lpc-busy]').forEach((link) => {
      delete link.dataset.lpcBusy;
      link.removeAttribute('aria-busy');
    });
  });

  // lp_cta_click no dataLayer (mesmo evento das LPs de creators fora da Shopify)
  document.addEventListener('click', (event) => {
    const link = event.target.closest && event.target.closest('[data-lpc-cta]');
    if (!link) return;
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'lp_cta_click', cta: link.dataset.lpcCta, campaign: config.campaign });
    } catch (e) {
      /* rastreio nunca impede a ida ao carrinho */
    }
  });

  /* Acordeões: a resposta entra com fade ao abrir */
  function initAccordions(scope) {
    scope.querySelectorAll('.lpc-accordion__item > summary').forEach((summary) => {
      if (summary.dataset.lpcReady) return;
      summary.dataset.lpcReady = 'true';
      summary.addEventListener('click', () => {
        const details = summary.parentElement;
        if (reducedMotion.matches || details.open) return;
        const answer = details.lastElementChild;
        if (answer && answer.animate) {
          answer.animate(
            [{ opacity: 0, transform: 'translateY(-4px)' }, { opacity: 1, transform: 'none' }],
            { duration: 350, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
          );
        }
      });
    });
  }

  /* Vídeos: tocar no card toca/pausa (mudo, em loop) */
  function initVideos(scope) {
    scope.querySelectorAll('[data-lpc-video]').forEach((card) => {
      if (card.dataset.lpcReady) return;
      card.dataset.lpcReady = 'true';
      const video = card.querySelector('video');
      if (!video) return;
      const label = card.dataset.label || '';
      const setState = (playing) => {
        card.classList.toggle('is-playing', playing);
        card.setAttribute('aria-label', `${playing ? 'Pausar' : 'Tocar'} ${label}`);
      };
      card.addEventListener('click', () => {
        if (video.paused) {
          video.play().then(() => setState(true)).catch(() => setState(false));
        } else {
          video.pause();
          setState(false);
        }
      });
    });
  }

  /* Barras fixas: aparecem quando o botão do hero sai por cima da tela e somem
     enquanto a área de compra da oferta está na tela */
  function initSticky() {
    const bars = document.querySelectorAll('[data-lpc-sticky]');
    if (!bars.length || bars[0].dataset.lpcReady) return;
    bars.forEach((bar) => (bar.dataset.lpcReady = 'true'));

    const heroCta = document.querySelector('[data-lpc-cta="hero"]');
    const offer = document.querySelector('[data-lpc-offer]');
    const bottomBar = document.querySelector('[data-lpc-sticky-bottom]');
    let visible = false;
    let ticking = false;

    const update = () => {
      ticking = false;
      const vh = window.innerHeight;
      const pastHero = heroCta ? heroCta.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
      let onOffer = false;
      if (offer) {
        const r = offer.getBoundingClientRect();
        onOffer = r.top < vh - 24 && r.bottom > 24;
      }
      const next = pastHero && !onOffer;
      if (next === visible) return;
      visible = next;
      bars.forEach((bar) => {
        bar.classList.toggle('is-visible', visible);
        bar.toggleAttribute('inert', !visible);
        if (visible) bar.removeAttribute('aria-hidden');
        else bar.setAttribute('aria-hidden', 'true');
      });
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    update();

    // Reserva no fim do rodapé a altura da barra de baixo (celular), para ela nunca cobrir o fim da página
    if (bottomBar) {
      const reserve = () => {
        const space = bottomBar.getClientRects().length ? bottomBar.offsetHeight : 0;
        document.body.style.setProperty('--lpc-bar-space', `${space}px`);
      };
      if ('ResizeObserver' in window) new ResizeObserver(reserve).observe(bottomBar);
      window.matchMedia('(min-width: 900px)').addEventListener('change', reserve);
      reserve();
    }
  }

  function init(scope = document) {
    initCtas(scope);
    initAccordions(scope);
    initVideos(scope);
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  /* Editor de temas: sections recarregadas individualmente */
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
